<template>
  <div id="app">
    <div v-if="!showDetail">
      <div v-for="(category, categoryId) in faqsByCategory" :key="categoryId" class="category-section">
        <h4 class="category">{{ category.name }}</h4>
        <div v-for="(faq, index) in category.faqs" :key="faq.id" class="faq-item">
          <div class="line"></div>
          <div class="faq-title" @click="toggleAnswer(categoryId, index)">
            <h5 :class="{ 'font-bold': faq.isOpen }" class="faq-question">
              <span class="iconQ mr-3">Q. </span>
              {{ faq.question }}
            </h5>
            <img :src="faq.isOpen ? require('@/assets/images/arrow.svg') : require('@/assets/images/arrow.svg')"
              alt="arrow" class="arrow-icon" :class="{ 'open': faq.isOpen }" />
          </div>
          <div v-if="faq.isOpen" class="faq-answer open">
            <div class="faq-answer-content">
              <span class="iconA mr-3">A. </span>
              <p v-html="faq.showReadMore ? faq.answer : faq.answer.substring(0, maxLengthText)" @click="handleLink"
                class="faq-text"></p>
            </div>
            <span v-if="faq.answer.length > maxLengthText">
              <a href="#" v-if="faq.showReadMore" @click.prevent="showFaqDetail(categoryId, index)" class="read-more">
                もっと読む
              </a>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showDetail">
      <p class="breadcrumb">
        <a href="#" @click.prevent="showDetail = false" class="text-brec">ヘルプ</a>
        >
        <a href="#" class="text-brec">{{ currentCategory.name }}</a>
      </p>
      <div class="faq-title">
        <h2 class="faq-detail-question">{{ currentFaq.question }}</h2>
      </div>
      <div class="answer-detail">
        <p v-html="currentFaq.answer"></p>
      </div>
      <div>
        <a href="#" @click.prevent="showDetail = false" class="text-brec">戻る</a>
      </div>
    </div>
  </div>
</template>


<script>
import api from "@/api";

export default {
  data() {
    return {
      faqsByCategory: {},
      categories: [],
      showDetail: false,
      currentCategory: null,
      currentFaq: null,
      maxLengthText: 500,
    };
  },
  created() {
    this.fetchFaq();
  },
  methods: {

    handleLink(event) {
      const message = { action: 'navigate', screen: '' };

      switch (event.target.id) {
        case 'hipscore':
          message.screen = 'HIP_SCORE';
          break;
        case 'locomo25':
          message.screen = 'LOCOMO25';
          break;
        case 'locomo7':
          message.screen = 'LOCOMO7';
          break;
        case 'listvideohome':
          message.screen = 'LIST_VIDEO_HOME';
          break;
        case 'termpolicy':
          message.screen = 'TERM_POLICY';
          break;
        case 'METScreenSlide':
          message.screen = 'MET_SLIDE';
          break;
        default:
          console.error('Unknown target id:', event.target.id);
          return;
      }

      window.ReactNativeWebView.postMessage(JSON.stringify(message));
    },


    async fetchFaq() {
      try {
        const response = await api.faq();
        if (response.status === 200) {
          const items = response.data;
          this.faqsByCategory = items.reduce((acc, faq) => {
            if (!acc[faq.categories_faq_id]) {
              acc[faq.categories_faq_id] = {
                name: faq.name,
                faqs: [],
              };
            }
            faq.isOpen = false;
            faq.showReadMore = faq.answer.length > this.maxLengthText;
            acc[faq.categories_faq_id].faqs.push(faq);
            return acc;
          }, {});
          this.categories = Object.values(this.faqsByCategory);
        }
      } catch (error) {
        console.error('Error fetching FAQs:', error);
      }
    },
    toggleAnswer(categoryId, index) {
      this.$set(this.faqsByCategory[categoryId].faqs[index], 'isOpen', !this.faqsByCategory[categoryId].faqs[index].isOpen);
    },
    showFaqDetail(categoryId, index) {
      const faq = this.faqsByCategory[categoryId].faqs[index];
      this.showDetail = true;
      this.currentCategory = this.faqsByCategory[categoryId];
      this.currentFaq = faq;
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;700&display=swap');

#app {
  padding: 10px;
  margin-top: -10px;
}

.category-section {
  border: 1px solid #ddd;
  background-color: #fff;
  border-radius: 8px;
  margin-bottom: 20px;
  margin-top: 10px;
  overflow: hidden;
}

.answer-detail {
  border: 1px solid #ddd;
  background-color: #fff;
  border-radius: 8px;
  margin-bottom: 20px;
  margin-top: 30px;
  overflow: hidden;
  font-size: 16px;
  font-weight: 400;
  padding: 15px 10px 0 10px;
  color: #000000;
}

.faq-item {
  background-color: #fff;
  padding: 0 10px;
}

.faq-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  min-height: 3.2rem;
}

.faq-question {
  color: #000000;
  line-height: 1.6rem;
}

.faq-answer {
  margin-top: 10px;
  margin-bottom: 10px;
  transition: max-height 0.6s ease-in-out, padding 0.6s ease-in-out;
  ;
}

.faq-answer.open {
  max-height: 500px;
  padding: 10px 0;
}

.faq-answer-content {
  display: flex;
  align-items: flex-start;
  margin-left: 20px;
}

.faq-text {
  margin: 10px 30px 10px 5px;
  font-size: 14px;
  font-weight: 400;
}

.read-more {
  color: green;
  font-weight: 400;
  margin-left: 20px;
}

.arrow-icon {
  height: 10px;
  margin-left: 20px;
}

.arrow-icon.open {
  transform: rotate(180deg);
}

.breadcrumb {
  font-weight: 400;
  font-size: 14px;
}

.faq-detail-question {
  font-weight: 400;
  margin-top: 10px;
  color: #000000;
}

.line {
  height: 1px;
  width: 110%;
  margin-bottom: 10px;
  transform: translateX(-10px);
  background-color: #dddddd;
}

.category {
  font-weight: 700;
  margin-top: 10px;
  margin-left: 10px;
  color: #000000;
  height: 2.2rem;
  padding-top: 0.4rem;
}

.text-brec {
  text-decoration: underline !important;
  color: green;
  font-weight: 400;
}

.iconQ {
  color: #F26739;
  font-weight: 700;
  font-size: 23px;
  font-family: Helvetica Neue Light, HelveticaNeue-Light, Helvetica Neue, Calibri, Helvetica, Arial;
}

.iconA {
  font-size: 23px;
  font-weight: 700;
  color: #d65541;
  font-family: Helvetica Neue Light, HelveticaNeue-Light, Helvetica Neue, Calibri, Helvetica, Arial;
}
</style>
